import { render, staticRenderFns } from "./listFaq.vue?vue&type=template&id=b96e9f98&scoped=true"
import script from "./listFaq.vue?vue&type=script&lang=js"
export * from "./listFaq.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96e9f98",
  null
  
)

export default component.exports